import {
  createStyles,
  makeStyles,
  Theme,
  Tooltip,
  Typography,
} from '@material-ui/core';
import styles from 'assets/styles/default.scss';
import React, { useMemo } from 'react';

/**
 * Baseado na ideia da unidade de tamanho relativo ``ch``
 * https://developer.mozilla.org/en-US/docs/Web/CSS/length#Font-relative_lengths
 */
const FONT_CH_WIDE = 26 / 2;

const TITLE_MAX_WIDTH = 60;

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        fontFamily: '"Exo 2", snas-serif',
        fontSize: 26,
        fontWeight: 700,
        color: styles.secondarySicrediDarker,
        [theme.breakpoints.up('lg')]: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      },
    }),
  { name: 'PageTitle' }
);
export interface IPageTitle {
  title: string;
  titleMaxLength?: number | null;
  className?: string;
  style?: React.CSSProperties;
}

export default function PageTitle({
  title,
  className = '',
  style,
}: IPageTitle) {
  const classes = useStyles();

  const needTooltip = useMemo(() => {
    if (window.innerWidth < 1279) return false;
    return title!?.length * FONT_CH_WIDE > TITLE_MAX_WIDTH * FONT_CH_WIDE;
  }, [title]);

  return (
    <Tooltip title={needTooltip ? title : ''} placement='top-start' arrow>
      <Typography
        variant='h4'
        component='h1'
        className={[classes.root, className].join(' ').trim()}
        style={style}
      >
        {title}
      </Typography>
    </Tooltip>
  );
}
